export default class TokenExpiredException extends Error {
  constructor(message: string) {
    super(message);
  }
}
